import { render, staticRenderFns } from "./OrganizationalUnitList.vue?vue&type=template&id=3cd87de4&"
import script from "./OrganizationalUnitList.vue?vue&type=script&lang=js&"
export * from "./OrganizationalUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd87de4')) {
      api.createRecord('3cd87de4', component.options)
    } else {
      api.reload('3cd87de4', component.options)
    }
    module.hot.accept("./OrganizationalUnitList.vue?vue&type=template&id=3cd87de4&", function () {
      api.rerender('3cd87de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/OrganizationalUnitList.vue"
export default component.exports